<template>
  <section class="hp-hero">
    <!-- 移动端顶部 120px 纯色背景 + 60px 渐变 -->
    <div class="hp-hero__mask-top">
      <div class="hp-hero__mask-top-solid"></div>
      <div class="hp-hero__mask-top-fade"></div>
    </div>

    <!-- 视频背景 -->
    <div class="hp-hero__video">
      <!-- Vue 2 把 video 的 muted 当 DOM prop 处理，静态属性会被当成 falsy，必须写 :muted="true" -->
      <video autoplay loop playsinline :muted="true" :src="videoSrc"></video>
    </div>

    <!-- 移动端：视频固定在右下角，宽度充满屏幕 -->
    <div class="hp-hero__video-mobile">
      <!-- Vue 2 把 video 的 muted 当 DOM prop 处理，静态属性会被当成 falsy，必须写 :muted="true" -->
      <video autoplay loop playsinline :muted="true" :src="videoSrc"></video>
    </div>

    <!-- 左侧渐变遮罩 -->
    <div class="hp-hero__mask-left"></div>

    <!-- 内容 -->
    <div class="hp-hero__content">
      <div class="hp-hero__inner" data-aos="fade-up">
        <!-- 主标题 -->
        <h1 class="hp-hero__title">
          汇通数科
          <br />
          <span class="hp-hero__title-sub">
            <span class="hp-hero__title-blue">企业级</span>
            <span>的AI应用服务商</span>
          </span>
        </h1>

        <!-- 4 行小字文案 -->
        <div class="hp-hero__lines">
          <div
            v-for="(item, i) in lines"
            :key="i"
            class="hp-hero__line"
          >
            <!-- 左侧装饰：线性小图标 -->
            <LucideIcon :name="item.icon" :size="16" :stroke-width="1.5" class="hp-hero__line-icon" />
            <p class="hp-hero__line-text">{{ item.text }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// 对应 projects-vue 的 src/components/sections/HeroSection.vue
import LucideIcon from '@/components/LucideIcon.vue'

const LINES = [
  { text: '海量智能体协作系统，实现复杂任务的智能分解与执行', icon: 'bot' },
  { text: '企业级数据服务 + 存算大模型一体机，全链路AI能力', icon: 'database' },
  { text: '智能巡检机器人 + 零售服务机器人，赋能企业自动化升级', icon: 'crosshair' },
  { text: '全场景数字化解决方案，助力企业智能化转型', icon: 'layers' }
]

export default {
  name: 'HeroSection',
  components: { LucideIcon },
  data() {
    return {
      lines: LINES,
      // 视频放在 public/homePage 下，不进 bundle；BASE_URL 兼容 VUE_APP_PUBLIC_PATH
      videoSrc: `${process.env.BASE_URL}homePage/hero-bg.mp4`
    }
  }
}
</script>

<style lang="less" scoped>
@import './vars.less';

.hp-hero {
  position: relative;
  height: 600px;
  display: flex;
  align-items: center;
  overflow: hidden;
  background: #e0eaf2;

  @media (min-width: @screen-md) {
    height: auto;
    min-height: 100vh;
  }
}

// 移动端顶部遮罩
.hp-hero__mask-top {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2;

  @media (min-width: @screen-md) {
    display: none;
  }
}
.hp-hero__mask-top-solid {
  height: 120px;
  background: #e0eaf2;
}
.hp-hero__mask-top-fade {
  height: 60px;
  background: linear-gradient(to bottom, #e0eaf2, rgba(224, 234, 242, 0));
}

// 视频背景
.hp-hero__video {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 0;

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: right;

    @media (min-width: @screen-md) {
      object-position: center;
    }
  }
}

// 移动端右下角视频（330pt = 440px）
.hp-hero__video-mobile {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 1;
  width: 100%;
  height: 440px;
  overflow: hidden;

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: right;
  }

  @media (min-width: @screen-md) {
    display: none;
  }
}

// 左侧渐变遮罩
.hp-hero__mask-left {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0.5) 0%,
    rgba(255, 255, 255, 0.3) 50%,
    rgba(255, 255, 255, 0) 100%
  );
}

.hp-hero__content {
  .hp-container();
  position: relative;
  z-index: 10;
}

.hp-hero__inner {
  max-width: 576px;
}

// 主标题
.hp-hero__title {
  margin: 0 0 32px;
  font-size: 30px;
  font-weight: 700;
  color: @hp-ink;
  line-height: 1.6;

  @media (min-width: @screen-md) {
    font-size: 36px;
  }
  @media (min-width: @screen-lg) {
    font-size: 48px;
  }
}
.hp-hero__title-sub {
  font-size: 36px;

  @media (min-width: @screen-md) {
    font-size: 48px;
  }
  @media (min-width: @screen-lg) {
    font-size: 56px;
  }
}
.hp-hero__title-blue {
  color: @hp-blue;
}

// 4 行文案
.hp-hero__lines {
  .hp-hero__line + .hp-hero__line {
    margin-top: 20px;
  }
}
.hp-hero__line {
  display: flex;
  align-items: center;
}
.hp-hero__line-icon {
  margin-right: 8px;
  color: @hp-ink;
  flex-shrink: 0;
}
.hp-hero__line-text {
  margin: 0;
  font-size: 15px;
  line-height: 1.625;
  font-weight: 400;
  color: @hp-text;

  @media (min-width: @screen-md) {
    font-size: 16px;
  }
}
</style>
